import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

// root + head moved to theme components.MuiTableCell (applied globally, as the
// old `{ name: "MuiTableCell" }` injection did). Only headNotUppercase is used
// here as an actual className (opt-out of the uppercase header).
const useTableCellStyle = makeStyles()({
  headNotUppercase: {
    color: '#bebfc0',
    textTransform: 'none',
  },
});

const ListHeader = (props) => {
  const { desc, orderBy, onRequestOrder, fields, classTableHead, classTableCell, classTableSortLabel, headerDisableUppercase } = props;
  const { classes } = useStyles();
  const { classes: tableCellClasses } = useTableCellStyle();

  const createSortHandler = (property) => (event) => {
    if (typeof onRequestOrder === 'function') onRequestOrder(event, property);
  };

  return (
    <TableHead className={classTableHead}>
      <TableRow>
        {fields.map(
          (field, index) =>
            !field.hidden && (
              <TableCell
                colSpan={field?.colSpan}
                key={`${field.id || field.fieldName || ''}-${index}`}
                sortDirection={orderBy === field.id ? (desc ? 'desc' : 'asc') : false}
                className={`${classTableCell || ''} ${headerDisableUppercase ? tableCellClasses.headNotUppercase : ''}`}
                style={{
                  minWidth: field.minWidth || 'auto',
                  width: field.width || 'auto',
                }}
                align={field.align || 'left'}
              >
                {!field.isDisableSort ? (
                  <TableSortLabel active={orderBy === field.id} direction={desc ? 'desc' : 'asc'} onClick={createSortHandler(field.id)} className={classTableSortLabel}>
                    {field.label}
                    {orderBy === field.id ? <span className={classes.visuallyHidden}>{desc ? 'sorted descending' : 'sorted ascending'}</span> : null}
                  </TableSortLabel>
                ) : (
                  field.label
                )}
              </TableCell>
            ),
        )}
      </TableRow>
    </TableHead>
  );
};
export default React.memo(ListHeader);
